// extracted by mini-css-extract-plugin
export default {"percentage":"Clock_percentage__O1mS9","graph":"Clock_graph__jP5dt","slider":"Clock_slider__hRvqa","noExtras":"Clock_noExtras__Gikb4"};